import { useContext } from 'react';
import Context from 'src/contexts/ConfirmContext';
import type { ConfirmContextValue } from 'src/contexts/ConfirmContext';

const useConfirm = (): ConfirmContextValue => useContext<ConfirmContextValue>(Context);

export default useConfirm;
